import { IVector2d } from '../types/math';
import { normalizeAngle } from './utils';

export function cross(v1: IVector2d, v2: IVector2d): number {
  return v1.x * v2.y - v1.y * v2.x;
}

export function dot(v1: IVector2d, v2: IVector2d): number {
  return v1.x * v2.x + v1.y * v2.y;
}

export function opposite(v: IVector2d): IVector2d {
  return { x: -v.x, y: -v.y };
}

// angle为正时逆时针旋转
export function rotate(direction: IVector2d, angle: number): IVector2d {
  return {
    x: direction.x * Math.cos(angle) - direction.y * Math.sin(angle),
    y: direction.x * Math.sin(angle) + direction.y * Math.cos(angle)
  };
}

export function getAngle(direction: IVector2d): number {
  return normalizeAngle(Math.atan2(direction.y, direction.x));
}

export function getDirectionFromAngle(angle: number): IVector2d {
  return { x: Math.cos(angle), y: Math.sin(angle) };
}
